var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"esg_rating_indication_table_table"},[_c('vxe-grid',{ref:"xTree",attrs:{"border":"","resizable":"","show-overflow":"","width":"100%","keep-source":"","data":_vm.data,"tree-config":{children: 'children', expandAll: true, trigger: 'cell'},"columns":_vm.tableColumn}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7168faaf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/esg/components/ESGRatingIndicationTable.vue
// module id = null
// module chunks = 